import React from "react";
import { FaWhatsapp, FaCheck, FaMusic, FaVideo, FaSearch, FaCalendarAlt, FaCalendarCheck } from "react-icons/fa";
import Footer from "../../components/Footer/footer";
import { deepMerge, useSiteContent } from "../../content/SiteContentContext";

const WHATSAPP_NUMBER = "358443519265";

const copy = {
  fi: {
    badge: "Muusikko- ja esiintyjäsivut alkaen 700 €",
    title: "Verkkosivut muusikoille ja esiintyjille",
    lead:
      "Olit sitten trubaduuri, sooloartisti, DJ, juontaja tai muu esiintyjä, rakennan sivuston täysin räätälöitynä sinun musiikkisi, palveluidesi ja keikkamyynnin ympärille. Sivusto näyttää hyvältä mobiilissa, tukee löydettävyyttä ja ohjaa tilaajan ottamaan yhteyttä. Muusikko- ja esiintyjäsivut alkaen 700 €.",
    primaryCta: "Pyydä arvio WhatsAppilla",
    secondaryCta: "Täytä lomake etusivulla",
    pricingCta: "Katso verkkosivujen hinnat",
    trust: ["Perus-SEO mukana", "Mobiili ensin", "WhatsApp-yhteydenotto", "Hakukoneille luettava HTML"],

    whoTitle: "Kenelle sivu sopii?",
    whoLead:
      "Erityisesti esiintyjille, joiden sivun pitää vakuuttaa tilaaja nopeasti ja tehdä yhteydenotosta helppoa.",
    who: [
      "Muusikot, trubaduurit ja laulaja-kitaristit",
      "Bilebändit, duot ja triot",
      "DJ:t ja ohjelmapalvelut",
      "Juontajat, koomikot ja esiintyvät taiteilijat",
      "Artistit, jotka tarvitsevat oman myyntikanavan",
    ],

    featuresTitle: "Mitä sivulle voidaan tehdä?",
    features: [
      {
        icon: "music",
        title: "Artistin myyntisivu",
        text: "Selkeä etusivu, joka kertoo heti kuka olet, mihin tilaisuuksiin sovit ja miten sinut saa varattua.",
      },
      {
        icon: "video",
        title: "Videot, kuvat ja some",
        text: "YouTube-videot, Instagram, TikTok, kuvat ja tärkeimmät nostot esiin ilman raskasta ja sekavaa rakennetta.",
      },
      {
        icon: "calendar",
        title: "Keikat ja kokoonpanot",
        text: "Keikkakalenteri, julkiset esiintymiset, duo/trio/bändi-kokoonpanot ja palvelupaketit selkeästi näkyville.",
      },
      {
        icon: "search",
        title: "SEO ja löydettävyys",
        text: "Sivurakenne, otsikot, metat, hakukoneille luettava HTML ja paikallinen löydettävyys huomioidaan alusta asti.",
      },
      {
        icon: "booking",
        title: "Buukkeri-varausupotus",
        text: "Halutessasi sivulle voidaan lisätä Buukkerin varausupotus, jolloin kävijä voi lähettää varauskyselyn suoraan omalta sivultasi.",
      },
    ],

    embedTitle: "Buukkeri-varausupotus omille sivuille",
    embedLead:
      "Buukkeri-embed tarkoittaa, että esiintyjän omille sivuille voidaan lisätä valmis varaus- tai tarjouspyyntötoiminto.",
    embedText:
      "Kävijä voi lähettää varauskyselyn suoraan sivuiltasi, ja kysely ohjautuu Buukkerin kautta hallittavaksi. Tämä sopii esiintyjälle, joka haluaa omille sivuilleen selkeämmän buukkauspolun ilman erillistä raskasta järjestelmää.",
    embedCta: "Lue lisää Buukkeri-embedistä",

    toolsTitle: "Keikan ympärille myös toimivat työkalut",
    toolsLead:
      "Esiintyjän verkkosivut voidaan yhdistää palveluihin, jotka helpottavat buukkausta ja yleisön osallistamista. Buukkeri ja Paranoidi ovat erillisiä palveluita, eivätkä ne sisälly automaattisesti verkkosivuprojektin hintaan.",
    tools: [
      {
        title: "Buukkeri – varauskyselyt omilta sivuilta",
        text: "Buukkeri-varausupotuksella asiakas voi lähettää tarjous- tai varauskyselyn suoraan esiintyjän omilta verkkosivuilta.",
        href: "https://buukkeri.fi/buukkeri-embed/",
        cta: "Tutustu Buukkeri-embediin",
        articleHref: "https://buukkeri.fi/blogi/buukkeri-embed-omille-kotisivuille/",
        articleCta: "Lue Buukkeri-embedistä",
      },
      {
        title: "Paranoidi – biisitoiveet ja keikkatyökalut",
        text: "Paranoidi tuo keikalle biisitoiveet, ohjelmiston ja muita esiintyjän työkaluja osaksi keikkakokemusta.",
        href: "https://paranoidi.fi/",
        cta: "Tutustu Paranoidiin",
        articleHref: "https://buukkeri.fi/blogi/esiintyjan-verkkosivu-osana-keikkaa-matti-oksa-paranoidi/",
        articleCta: "Lue Matti Oksa -case",
      },
    ],

    referencesTitle: "Referenssit samasta maailmasta",
    referencesLead:
      "Näissä projekteissa yhdistyvät esiintyjän myynti, hyvä mobiilikokemus, sisältöjen selkeys ja hakukonenäkyvyys.",
    references: [
      {
        title: "TrubaduuriPekka.fi",
        text: "Moderni artistisivusto trubaduurille ja eri kokoonpanoille. Painotus mobiilikäytössä, kuvissa, videoissa, palveluesittelyssä ja yhteydenoton helppoudessa.",
        href: "https://www.trubaduuripekka.fi/",
      },
      {
        title: "Bilebändi Joyride",
        text: "Bändisivusto, jossa brändi, ohjelmisto, keikkafiilis ja yhteydenotto tukevat keikkamyyntiä.",
        href: "https://bilebandijoyride.com/",
      },
      {
        title: "Nico Bertula",
        text: "Muusikon ja esiintyjän moderni verkkosivusto, jossa trubaduuri-, duo- ja bändikokoonpanot, keikat, videot ja yhteydenotto muodostavat selkeän kokonaisuuden.",
        href: "https://nicobertula.fi/",
        articleHref: "https://buukkeri.fi/blogi/nico-bertula-uudet-verkkosivut/",
        articleCta: "Lue verkkosivuprojektista",
      },
    ],

    priceTitle: "Hinta alkaen 700 €",
    priceText:
      "Kevyt artisti- tai esiintyjäsivusto alkaa 700 eurosta. Perus-SEO kuuluu toteutukseen. Tarvittaessa hosting ja tekninen ylläpito voidaan järjestää 360 €/vuosi. Projektin maksun voi sopia myös 1–3 erään.",
    priceItems: [
      "Täysin räätälöity verkkosivutoteutus tarpeen mukaan",
      "Perus-SEO ja hakukoneille luettava sisältö",
      "Responsiivinen toteutus mobiiliin, tablettiin ja desktopiin",
      "WhatsApp-yhteydenotto valmiilla viestillä",
    ],

    processTitle: "Miten projekti etenee?",
    process: [
      {
        title: "1. Katsotaan tavoite",
        text: "Mihin keikkoihin tai asiakkaisiin sivun pitää osua ja mitä kävijän pitäisi tehdä?",
      },
      {
        title: "2. Rakennetaan selkeä rakenne",
        text: "Etusivu, palvelut, kokoonpanot, videot, kuvat, referenssit ja yhteydenotto järjestetään myyvästi.",
      },
      {
        title: "3. Julkaistaan ja mitataan",
        text: "Sivu viedään julkaisuun, perus-SEO tarkistetaan ja yhteydenotot tehdään mahdollisimman helpoiksi.",
      },
    ],

    faqTitle: "Usein kysyttyä esiintyjän verkkosivuista",
    faqLead:
      "Näihin kysymyksiin törmätään usein, kun artistille, bändille tai muulle esiintyjälle rakennetaan myyvää verkkosivua.",
    faq: [
      {
        q: "Kenelle esiintyjäsivut sopivat?",
        a: "Sivut sopivat artisteille, bändeille, trubaduureille, DJ:lle, juontajille, koomikoille ja ohjelmapalveluille, jotka haluavat oman selkeän myyntikanavan.",
      },
      {
        q: "Mitä esiintyjän sivuille voidaan lisätä?",
        a: "Sivuille voidaan lisätä videot, kuvat, keikkakalenteri, kokoonpanot, ohjelmisto, somekanavat, yhteydenotto ja hakukoneille luettava sisältö.",
      },
      {
        q: "Voiko sivuille upottaa Buukkerin varausjärjestelmän?",
        a: "Kyllä. Halutessasi sivuille voidaan upottaa Buukkerin buukkausjärjestelmä, jolloin kävijä voi lähettää varauskyselyn suoraan sivuiltasi.",
      },
      {
        q: "Paljonko esiintyjän verkkosivut maksavat?",
        a: "Kevyt artisti- tai esiintyjäsivusto alkaa 700 eurosta. Lopullinen hinta riippuu sisällöistä, laajuudesta ja mahdollisista lisätoiminnoista.",
      },
      {
        q: "Voiko sivulle lisätä videoita, kuvia ja keikkakalenterin?",
        a: "Kyllä. Esiintyjäsivun tärkeimpiä osia ovat yleensä videot, kuvat, keikat, referenssit ja selkeä yhteydenottopolku.",
      },
     {
        q: "Saako sivustolle hostingin ja ylläpidon?",
        a: "Kyllä. Tarvittaessa hosting ja tekninen ylläpito voidaan järjestää 360 €/vuosi.",
      },
      {
        q: "Voiko verkkosivut maksaa erissä?",
        a: "Kyllä. Projektin maksun voi sopia 1–3 erään.",
      },
    ],

    finalTitle: "Haluatko artistisivun, joka tuo yhteydenottoja?",
    finalLead:
      "Laita viesti WhatsAppilla, täytä lomake etusivulla tai laske ensin suuntaa-antava kustannus hinnastolaskurilla.",
  },

  en: {
    badge: "Performer websites starting from €700",
    title: "Websites for musicians and performers",
    lead:
      "Whether you are a troubadour, solo artist, DJ, host or another type of performer, I build the website around your music, services and booking goals instead of fitting you into an off-the-shelf template. The site works smoothly on mobile, supports search visibility and guides visitors to contact you. Performer websites start from €700.",
    primaryCta: "Request an estimate on WhatsApp",
    secondaryCta: "Fill the form on the front page",
    pricingCta: "See website pricing",
    trust: ["SEO included", "Mobile first", "WhatsApp contact", "Crawler-friendly HTML"],
    whoTitle: "Who is this for?",
    whoLead: "Especially for performers whose website needs to convince visitors quickly and make contact easy.",
    who: ["Musicians, troubadours and singer-guitarists", "Party bands, duos and trios", "DJs and event services", "Hosts, comedians and performers", "Artists who need their own sales channel"],
    featuresTitle: "What can be included?",
    features: [
      { icon: "music", title: "Performer sales page", text: "A clear front page that quickly explains who you are, where you fit and how to book you." },
      { icon: "video", title: "Videos, photos and social media", text: "YouTube videos, Instagram, TikTok, photos and highlights presented clearly without a heavy structure." },
      { icon: "calendar", title: "Gigs and lineups", text: "Gig calendar, public shows, duo/trio/band lineups and service packages presented clearly." },
      { icon: "search", title: "SEO and visibility", text: "Page structure, headings, metadata, crawler-friendly HTML and local visibility are considered from the start." },
      { icon: "booking", title: "Buukkeri booking embed", text: "If you want, the Buukkeri booking system can be embedded on your website so visitors can send booking inquiries directly from your own site." },
    ],

    embedTitle: "Buukkeri booking embed for your own website",
    embedLead:
      "A Buukkeri embed means that a ready-made booking or inquiry function can be added to your performer website.",
    embedText:
      "Visitors can send booking inquiries directly from your own site, and the inquiry is handled through Buukkeri. This is useful if you want a clearer booking path without building a heavy custom system from scratch.",
    embedCta: "Read more about the Buukkeri embed",

    toolsTitle: "Useful tools around the gig",
    toolsLead:
      "A performer website can be connected with services that make booking and audience interaction easier. Buukkeri and Paranoidi are separate services and are not automatically included in the website project price.",
    tools: [
      {
        title: "Buukkeri – booking inquiries from your own website",
        text: "With the Buukkeri booking embed, customers can send booking or quote requests directly from your performer website.",
        href: "https://buukkeri.fi/buukkeri-embed/",
        cta: "Explore Buukkeri embed",
        articleHref: "https://buukkeri.fi/blogi/buukkeri-embed-omille-kotisivuille/",
        articleCta: "Read about the embed",
      },
      {
        title: "Paranoidi – song requests and gig tools",
        text: "Paranoidi brings song requests, repertoire and other performer tools into the gig experience.",
        href: "https://paranoidi.fi/",
        cta: "Explore Paranoidi",
        articleHref: "https://buukkeri.fi/blogi/esiintyjan-verkkosivu-osana-keikkaa-matti-oksa-paranoidi/",
        articleCta: "Read the Matti Oksa case",
      },
    ],

    referencesTitle: "Relevant references",
    referencesLead: "These projects combine performer sales, mobile usability, clear content and search visibility.",
    references: [
      { title: "TrubaduuriPekka.fi", text: "A modern performer website for a troubadour and different lineups.", href: "https://www.trubaduuripekka.fi/" },
      { title: "Bilebändi Joyride", text: "A band website where brand, repertoire and contact paths support booking inquiries.", href: "https://bilebandijoyride.com/" },
      {
        title: "Nico Bertula",
        text: "A modern performer website combining different lineups, gigs, videos and clear contact paths.",
        href: "https://nicobertula.fi/",
        articleHref: "https://buukkeri.fi/blogi/nico-bertula-uudet-verkkosivut/",
        articleCta: "Read about the website project",
      },
    ],
    priceTitle: "Starting from €700",
    priceText: "A lightweight artist or performer website starts from €700. Basic SEO is included. Hosting and technical maintenance can be arranged for €360/year when needed. The project payment can also be split into 1–3 instalments.",
    priceItems: ["Custom-built website implementation based on your needs", "Basic SEO and crawler-friendly content", "Responsive mobile, tablet and desktop layout", "WhatsApp contact with a ready-made message"],
    processTitle: "How the project works",
    process: [
      { title: "1. Define the goal", text: "What type of bookings should the website support and what should visitors do?" },
      { title: "2. Build a clear structure", text: "Home, services, lineups, videos, photos, references and contact paths are arranged clearly." },
      { title: "3. Publish and measure", text: "The site is launched, basic SEO is checked and contact paths are made as easy as possible." },
    ],
    faqTitle: "Frequently asked questions",
    faqLead: "Common questions when building a website for an artist, band or performer.",
    faq: [
      {
        q: "Who are performer websites for?",
        a: "They are suitable for artists, bands, troubadours, DJs, hosts, comedians and event services that need a clear sales channel of their own.",
      },
      {
        q: "What can be added to a performer website?",
        a: "Videos, photos, gig calendar, lineups, repertoire, social channels, contact options and crawler-friendly content can be included.",
      },
      {
        q: "Can the Buukkeri booking system be embedded?",
        a: "Yes. The Buukkeri booking system can be embedded so visitors can send booking inquiries directly from your website.",
      },
      {
        q: "How much does a performer website cost?",
        a: "A lightweight artist or performer website starts from €700. The final price depends on content, scope and additional features.",
      },
      {
        q: "Can videos, photos and a gig calendar be added?",
        a: "Yes. Videos, photos, gigs, references and a clear contact path are usually some of the most important parts of a performer website.",
      },
    {
        q: "Can hosting and maintenance be included?",
        a: "Yes. Hosting and technical maintenance can be arranged for €360/year when needed.",
      },
      {
        q: "Can the website be paid in instalments?",
        a: "Yes. The project payment can be split into 1–3 instalments.",
      },
    ],

    finalTitle: "Want a performer website that generates inquiries?",
    finalLead: "Send a WhatsApp message, fill in the form on the front page or calculate an estimated cost with the website price calculator.",
  },

  es: {
    badge: "Webs para artistas desde 700 €",
    title: "Webs para músicos y artistas",
    lead:
      "Ya seas trovador, solista, DJ, presentador u otro artista, construyo la web a medida alrededor de tu música, servicios y objetivos de contratación, sin adaptarte a una plantilla prefabricada. La web funciona bien en móvil, apoya la visibilidad en buscadores y facilita el contacto. Webs para artistas desde 700 €.",
    primaryCta: "Pedir estimación por WhatsApp",
    secondaryCta: "Rellenar formulario en la página principal",
    pricingCta: "Ver precios de páginas web",
    trust: ["SEO incluido", "Móvil primero", "Contacto por WhatsApp", "HTML para buscadores"],
    whoTitle: "¿Para quién es?",
    whoLead: "Especialmente para artistas cuya web debe convencer rápido y facilitar el contacto.",
    who: ["Músicos, trovadores y cantautores", "Bandas, dúos y tríos", "DJs y servicios para eventos", "Presentadores, cómicos y artistas", "Artistas que necesitan su propio canal de venta"],
    featuresTitle: "¿Qué puede incluir?",
    features: [
      { icon: "music", title: "Página de venta para artista", text: "Una página clara que explica quién eres, para qué eventos encajas y cómo reservarte." },
      { icon: "video", title: "Vídeos, fotos y redes", text: "YouTube, Instagram, TikTok, fotos y destacados presentados de forma clara." },
      { icon: "calendar", title: "Conciertos y formaciones", text: "Calendario, próximas fechas, dúo/trío/banda y paquetes de servicio claramente visibles." },
      { icon: "search", title: "SEO y visibilidad", text: "Estructura, títulos, metadatos, HTML para buscadores y visibilidad local desde el inicio." },
      { icon: "booking", title: "Integración de reservas Buukkeri", text: "Si quieres, se puede integrar el sistema de reservas de Buukkeri para que los visitantes envíen solicitudes directamente desde tu web." },
    ],

    embedTitle: "Integración Buukkeri en tu propia web",
    embedLead:
      "La integración Buukkeri significa que se puede añadir una función de reservas o solicitudes directamente en la web del artista.",
    embedText:
      "El visitante puede enviar una solicitud desde tu propia web y la solicitud se gestiona mediante Buukkeri. Es útil si quieres un camino de reserva claro sin construir un sistema pesado desde cero.",
    embedCta: "Leer más sobre Buukkeri embed",

    toolsTitle: "Herramientas útiles alrededor del concierto",
    toolsLead:
      "La web de un artista puede conectarse con servicios que facilitan las reservas y la participación del público. Buukkeri y Paranoidi son servicios independientes y no están incluidos automáticamente en el precio del proyecto web.",
    tools: [
      {
        title: "Buukkeri – solicitudes desde tu propia web",
        text: "Con la integración de Buukkeri, el cliente puede enviar una solicitud de reserva o presupuesto directamente desde tu web.",
        href: "https://buukkeri.fi/buukkeri-embed/",
        cta: "Conocer Buukkeri embed",
        articleHref: "https://buukkeri.fi/blogi/buukkeri-embed-omille-kotisivuille/",
        articleCta: "Leer sobre la integración",
      },
      {
        title: "Paranoidi – peticiones de canciones y herramientas para conciertos",
        text: "Paranoidi añade peticiones de canciones, repertorio y otras herramientas para el artista alrededor del concierto.",
        href: "https://paranoidi.fi/",
        cta: "Conocer Paranoidi",
        articleHref: "https://buukkeri.fi/blogi/esiintyjan-verkkosivu-osana-keikkaa-matti-oksa-paranoidi/",
        articleCta: "Leer el caso de Matti Oksa",
      },
    ],

    referencesTitle: "Referencias relevantes",
    referencesLead: "Estos proyectos combinan venta de artistas, buena experiencia móvil, contenido claro y visibilidad.",
    references: [
      { title: "TrubaduuriPekka.fi", text: "Web moderna para un trovador y diferentes formaciones.", href: "https://www.trubaduuripekka.fi/" },
      { title: "Bilebändi Joyride", text: "Web de banda donde marca, repertorio y contacto apoyan las reservas.", href: "https://bilebandijoyride.com/" },
      {
        title: "Nico Bertula",
        text: "Una web moderna para músico y artista que reúne diferentes formaciones, conciertos, vídeos y un contacto claro.",
        href: "https://nicobertula.fi/",
        articleHref: "https://buukkeri.fi/blogi/nico-bertula-uudet-verkkosivut/",
        articleCta: "Leer sobre el proyecto web",
      },
    ],
    priceTitle: "Desde 700 €",
    priceText: "Una web ligera para artista empieza desde 700 €. El SEO básico está incluido. Si es necesario, se puede contratar hosting y mantenimiento técnico por 360 €/año. El pago del proyecto también puede dividirse en 1–3 cuotas.",
    priceItems: ["Implementación web totalmente a medida según necesidad", "SEO básico y contenido para buscadores", "Diseño responsive para móvil, tablet y escritorio", "Contacto por WhatsApp con mensaje preparado"],
    processTitle: "Cómo avanza el proyecto",
    process: [
      { title: "1. Definimos el objetivo", text: "Qué tipo de reservas debe apoyar la web y qué debe hacer el visitante." },
      { title: "2. Construimos una estructura clara", text: "Inicio, servicios, formaciones, vídeos, fotos, referencias y contacto." },
      { title: "3. Publicamos y medimos", text: "Se lanza la web, se revisa el SEO básico y se facilita el contacto." },
    ],
    faqTitle: "Preguntas frecuentes",
    faqLead: "Preguntas comunes al construir una web para un artista, banda o profesional de eventos.",
    faq: [
      {
        q: "¿Para quién son las webs de artistas?",
        a: "Son adecuadas para artistas, bandas, trovadores, DJs, presentadores, cómicos y servicios de eventos que necesitan un canal propio de venta.",
      },
      {
        q: "¿Qué se puede añadir a una web de artista?",
        a: "Se pueden incluir vídeos, fotos, calendario, formaciones, repertorio, redes sociales, contacto y contenido legible para buscadores.",
      },
      {
        q: "¿Se puede integrar Buukkeri?",
        a: "Sí. Se puede integrar el sistema de reservas Buukkeri para que los visitantes envíen solicitudes directamente desde tu web.",
      },
      {
        q: "¿Cuánto cuesta una web de artista?",
        a: "Una web ligera para artista empieza desde 700 €. El precio final depende del contenido, alcance y funciones adicionales.",
      },
      {
        q: "¿Se pueden añadir vídeos, fotos y calendario?",
        a: "Sí. Vídeos, fotos, fechas, referencias y un contacto claro suelen ser partes importantes de una web de artista.",
      },
      {
        q: "¿Se puede incluir hosting y mantenimiento?",
        a: "Sí. Si es necesario, se puede contratar hosting y mantenimiento técnico por 360 €/año.",
      },
      {
        q: "¿Se puede pagar la web en cuotas?",
        a: "Sí. El pago del proyecto puede dividirse en 1–3 cuotas.",
      },
    ],

    finalTitle: "¿Quieres una web de artista que genere contactos?",
    finalLead: "Envíame un mensaje por WhatsApp, rellena el formulario en la página principal o calcula un coste orientativo con la calculadora.",
  },
};

const iconMap = {
  music: FaMusic,
  video: FaVideo,
  calendar: FaCalendarAlt,
  search: FaSearch,
  booking: FaCalendarCheck,
};

function buildWhatsAppUrl(lang, whatsappNumber = WHATSAPP_NUMBER) {
  const message =
    lang === "en"
      ? "Hi Arttu! I am interested in a performer website and would like to ask for an estimate."
      : lang === "es"
      ? "Hola Arttu. Estoy interesado en una web para artista y me gustaría pedir una estimación."
      : "Hei Arttu! Olen kiinnostunut esiintyjän verkkosivuista ja haluaisin pyytää arviota toteutuksesta.";

  return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
}

export default function MusicianWebsiteLandingPage({ lang = "fi", prefix = "" }) {
  const siteContent = useSiteContent();
  const currentLang = lang === "en" || lang === "es" ? lang : "fi";
  const t = deepMerge(
    copy[currentLang],
    siteContent?.pages?.musician?.[currentLang] || {}
  );
  const whatsappUrl = buildWhatsAppUrl(
    currentLang,
    siteContent?.settings?.whatsappNumber || WHATSAPP_NUMBER
  );

  return (
    <>
      <main className="mx-auto w-full max-w-7xl px-6 pb-24 pt-28 md:px-10 lg:px-16">
        <section className="relative overflow-hidden rounded-[2rem] border border-black/10 bg-white/75 px-6 py-12 text-center shadow-[0_20px_80px_rgba(0,0,0,0.12)] backdrop-blur dark:border-white/10 dark:bg-white/5 md:px-10 md:py-16">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-lime-400/20 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-sky-400/20 blur-3xl" />

          <div className="relative z-10">
            <div className="mb-5 inline-flex rounded-full border border-lime-400/30 bg-lime-400/10 px-4 py-2 text-xs font-bold uppercase tracking-wide text-lime-700 dark:text-lime-300">
              {t.badge}
            </div>

            <h1 className="mx-auto max-w-5xl text-4xl font-black tracking-tight text-gray-950 dark:text-white md:text-6xl">
              {t.title}
            </h1>

            <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-gray-700 dark:text-gray-200">
              {t.lead}
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]"
              >
                <FaWhatsapp className="h-5 w-5" />
                {t.primaryCta}
              </a>

              <a
                href={`${prefix || ""}/#contact`}
                className="inline-flex rounded-full border border-black/10 bg-white/80 px-6 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
              >
                {t.secondaryCta}
              </a>

              <a
                href={`${prefix || ""}/verkkosivujen-hinta`}
                className="inline-flex rounded-full border border-lime-400/40 bg-lime-400/10 px-6 py-3 font-semibold text-lime-800 backdrop-blur transition hover:-translate-y-[1px] dark:text-lime-200"
              >
                {t.pricingCta}
              </a>
            </div>

            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {t.trust.map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-black/10 bg-white/70 px-3 py-1 text-xs font-bold text-gray-700 dark:border-white/10 dark:bg-black/20 dark:text-gray-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">
            <h2 className="text-2xl font-black text-gray-950 dark:text-white">{t.whoTitle}</h2>
            <p className="mt-3 text-gray-700 dark:text-gray-200">{t.whoLead}</p>

            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">
              {t.who.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                    <FaCheck className="h-3 w-3" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">
            <h2 className="text-2xl font-black text-gray-950 dark:text-white">{t.featuresTitle}</h2>

            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {t.features.map((item) => {
                const Icon = iconMap[item.icon] || FaMusic;

                return (
                  <div
                    key={item.title}
                    className="rounded-2xl border border-black/10 bg-white/80 p-5 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                  >
                    <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                      <Icon className="h-4 w-4" />
                    </div>
                    <h3 className="font-black text-gray-950 dark:text-white">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">{item.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="mt-14 overflow-hidden rounded-[2rem] border border-lime-500/30 bg-lime-500/10 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
            <div>
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-lime-400/20 text-lime-700 dark:text-lime-300">
                <FaCalendarCheck className="h-5 w-5" />
              </div>

              <h2 className="text-3xl font-black text-gray-950 dark:text-white">
                {t.embedTitle}
              </h2>

              <p className="mt-4 text-lg leading-relaxed text-gray-800 dark:text-gray-100">
                {t.embedLead}
              </p>
            </div>

            <div className="rounded-2xl border border-black/10 bg-white/70 p-5 dark:border-white/10 dark:bg-black/20">
              <p className="leading-relaxed text-gray-700 dark:text-gray-200">
                {t.embedText}
              </p>

              <a
                href="https://buukkeri.fi/buukkeri-embed/"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex rounded-full border border-lime-400/40 bg-lime-400 px-5 py-3 font-bold text-black transition hover:bg-lime-300"
              >
                {t.embedCta}
              </a>
            </div>
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-black text-gray-950 dark:text-white">
              {t.toolsTitle}
            </h2>

            <p className="mt-3 leading-relaxed text-gray-700 dark:text-gray-200">
              {t.toolsLead}
            </p>
          </div>

          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {t.tools.map((item) => (
              <article
                key={item.title}
                className="rounded-2xl border border-black/10 bg-white/80 p-6 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
              >
                <h3 className="text-xl font-black text-gray-950 dark:text-white">
                  {item.title}
                </h3>

                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                  {item.text}
                </p>

                <div className="mt-5 flex flex-wrap gap-3">
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex rounded-full bg-lime-400 px-4 py-2 text-sm font-bold text-black transition hover:bg-lime-300"
                  >
                    {item.cta}
                  </a>

                  <a
                    href={item.articleHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex rounded-full border border-black/10 px-4 py-2 text-sm font-semibold text-gray-800 transition hover:border-lime-400/50 dark:border-white/10 dark:text-gray-100"
                  >
                    {item.articleCta}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="muusikko-referenssit" className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-3xl font-black text-gray-950 dark:text-white">{t.referencesTitle}</h2>
            <p className="mt-3 text-gray-700 dark:text-gray-200">{t.referencesLead}</p>
          </div>

          <div className="mt-8 grid gap-5 md:grid-cols-3">
            {t.references.map((item) => (
              <article
                key={item.title}
                className="group rounded-2xl border border-black/10 bg-white/80 p-5 transition hover:-translate-y-1 hover:border-lime-400/50 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
              >
                <h3 className="font-black text-gray-950 dark:text-white">
                  {item.title}
                </h3>

                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                  {item.text}
                </p>

                <div className="mt-5 flex flex-wrap gap-3">
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex rounded-full bg-lime-400 px-4 py-2 text-sm font-bold text-black transition hover:bg-lime-300"
                  >
                    {currentLang === "en"
                      ? "View website"
                      : currentLang === "es"
                      ? "Ver web"
                      : "Avaa verkkosivut"}
                  </a>

                  {item.articleHref && (
                    <a
                      href={item.articleHref}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex rounded-full border border-black/10 px-4 py-2 text-sm font-semibold text-gray-800 transition hover:border-lime-400/50 dark:border-white/10 dark:text-gray-100"
                    >
                      {item.articleCta}
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]">
          <div className="rounded-[2rem] border border-lime-500/30 bg-lime-500/10 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
            <h2 className="text-3xl font-black text-gray-950 dark:text-white">{t.priceTitle}</h2>
            <p className="mt-4 leading-relaxed text-gray-800 dark:text-gray-100">{t.priceText}</p>

            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">
              {t.priceItems.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <FaCheck className="mt-1 h-4 w-4 shrink-0 text-lime-600 dark:text-lime-300" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
            <h2 className="text-3xl font-black text-gray-950 dark:text-white">{t.processTitle}</h2>

            <div className="mt-6 grid gap-4">
              {t.process.map((item) => (
                <div key={item.title} className="rounded-2xl border border-black/10 bg-white/80 p-5 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5">
                  <h3 className="font-black text-gray-950 dark:text-white">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-black uppercase tracking-[0.25em] text-lime-700 dark:text-lime-300">
              FAQ
            </p>

            <h2 className="mt-3 text-3xl font-black text-gray-950 dark:text-white">
              {t.faqTitle}
            </h2>

            <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
              {t.faqLead}
            </p>
          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {t.faq.map((item) => (
              <article
                key={item.q}
                className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 transition hover:-translate-y-1 hover:border-lime-400/50 dark:border-white/10 dark:bg-black/20"
              >
                <h3 className="text-lg font-black text-gray-950 dark:text-white">
                  {item.q}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                  {item.a}
                </p>
              </article>
            ))}
          </div>
        </section>

        <section className="mt-14 rounded-[2rem] border border-lime-500/30 bg-lime-500/10 p-8 text-center shadow-xl md:p-10">
          <h2 className="mx-auto max-w-3xl text-3xl font-black text-gray-950 dark:text-white md:text-4xl">
            {t.finalTitle}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-700 dark:text-gray-200">
            {t.finalLead}
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02]"
            >
              <FaWhatsapp className="h-5 w-5" />
              {t.primaryCta}
            </a>

            <a
              href={`${prefix || ""}/#contact`}
              className="inline-flex rounded-full border border-black/10 bg-white/80 px-7 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
            >
              {t.secondaryCta}
            </a>

            <a
              href={`${prefix || ""}/verkkosivujen-hinta`}
              className="inline-flex rounded-full border border-lime-400/40 bg-lime-400/10 px-7 py-3 font-semibold text-lime-800 backdrop-blur transition hover:-translate-y-[1px] dark:text-lime-200"
            >
              {t.pricingCta}
            </a>
          </div>
        </section>
      </main>

      <Footer lang={currentLang} prefix={prefix} />
    </>
  );
}




